import moment from 'moment';
import 'moment/locale/fr';
import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TypeIntervention from '../../../common/data/PlanningData/type_intervention';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Input from '../../../components/bootstrap/forms/Input';
import Textarea from '../../../components/bootstrap/forms/Textarea';
import AuthContext from '../../../contexts/authContext';
import PoseContext from '../../../contexts/poseContext';
import Button from '../../bootstrap/Button';
import Card, {
	CardActions,
	CardBody,
	CardHeader,
	CardLabel,
	CardTabItem,
	CardTitle,
} from '../../bootstrap/Card';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '../../bootstrap/Modal';
import Option from '../../bootstrap/Option';
import Spinner from '../../bootstrap/Spinner';
import Select from '../../bootstrap/forms/Select';
import Icon from '../../icon/Icon';
import PosePopup from './PosePopup';

import motifIntervention from '../../../common/data/PlanningData/motif_intervention';
import createNotification from '../../../common/function/createNotification';
import { DevisLinesContextProvider } from '../../../contexts/devisLinesContext';
import Attachements from '../../Attachements/Attachements';
import SearchClient from '../../Clients/SearchClient';
import DevisCard from '../../Devis/DevisCard';
import DevisPopUp from '../../Devis/DevisPopUp';
import EmployeePopup from '../../Stock/EmployeePopup';
import Label from '../../bootstrap/forms/Label';
import useOutsideClick from '../../customComponents/SearchAutoComplete/useOutsideClick';
import ErrorPopup from '../../extras/ErrorPopup';
import SearchBoxClient from '../Client/SearchBoxClient';
import PopUpSeachDevisIntervention from '../PopUpSeachDevisIntervention';
import PopUpSeachParentIntervention from '../PopUpSeachParentIntervention';
import StatusPopup from '../StatusPopup';
import VoiturePopup from './VoiturePopup';
import { searchAPI } from '../../../nodeApi/cruds';
import SearchBox from '../../Stock/SearchBox';
//const { setPlanning } = useContext(PlanningContext);

const InterventionCreatePopUp = ({
	setCreateModalStatus,
	newInterventionData,
	getInterventions,
	clientData,
	newData,
	setEditModalStatus,
}) => {
	const { userData } = useContext(AuthContext);
	const [searchModalStatus, setSearchModalStatus] = useState(false);
	const [selectedClient, setSelectedClient] = useState(
		newInterventionData?.client || newData?.clientData || {},
	);
	console.log('newData', !!newData);
	const [selectedEmployee, setSelectedEmployee] = useState({});
	const [filterResult, setfilterResult] = useState({});
	const [parentInterventionsData, setParentInterventionsData] = useState([]);
	const [employeePopup, setEmployeePopup] = useState(false);

	const [formState, setFormState] = useState({
		...(newData || {
			start_datetime: moment().format('YYYY-MM-DD HH:mm:ss') || '',
			end_datetime: moment().add(1,"hour").format('YYYY-MM-DD HH:mm:ss') || '',
		})
	});

	const [curentInput, setCurentInput] = useState({ inputName: '', inputLabel: '' });
	const { t } = useTranslation(['translation', 'menu']);

	const [attachmentsCommercial, setAttachmentsCommercial] = useState(
		newData?.attachmentsCommercial || [],
	);

	const [error, setError] = useState();
	const { pose, setPose } = useContext(PoseContext);
	const [posePopup, setposePopup] = useState(!!Object.keys(pose).length);
	const [voiturePopup, setVoiturePopup] = useState(false);

	const handleClickOutside = () => {
		setOpenList(false);
	};
	const ref = useOutsideClick(handleClickOutside);
	const [openList, setOpenList] = useState(false);
	const [devisIsLoading, setDevisIsLoading] = useState(false);
	const [filterDevisResult, setFilterDevisResult] = useState({});
	const [devisInputSearch, setDevisInputSearch] = useState('');
	const [newDevisData, setNewDevisData] = useState({});
	const [devisDatas, setDevisDatas] = useState([]);
	const [editDevisModalStatus, setEditDevisModalStatus] = useState(false);
	const [obligation, setObligation] = useState(false);
	const [isFournisseur, setIsFournisseur] = useState(false);
	const [parentIntervention, setParentIntervention] = useState(false);
	const [parentDevis, setParentDevis] = useState(false);

	moment.locale('fr');
	const [isLoading, setisLoading] = useState(false);


	const getEmployes = async () => {
		const res = await searchAPI(userData?.accessToken, 'user', { company: userData?.company?.id });
		console.log("userData", userData)
		console.log("res", res)
		setUsers(res?.employees || []);
	};

	const handleCreateDevis = () => {
		if (userData && userData?.id && userData?.password) {
			const newDevis = {
				project_title: 'Devis ' + formState?.motif + ' ' + selectedClient?.name,
				client_id: selectedClient?.id,
				//ref_intervention: formState?.name_seq,
				//planning_id: formState?.id,
				//responsable_intervention: formState?.login_user?.id,
				// company_id: formState?.login_user?.company_id?.id,
				techniciens: formState?.voitures?.map((voiture) =>
					voiture?.conducteur?.map((item) => {
						return item?.id;
					}),
				),
			};
			// createDevis(
			// 	userData?.password,
			// 	newDevis,
			// 	(devisData) => {
			// 		handelSelectDevis(devisData);
			// 		setNewDevisData(devisData);
			// 		setEditDevisModalStatus(true);
			// 	},
			// 	(error) => {
			// 		setError(error);
			// 	},
			// );
		}
	};


	const handleCreateIntervention = () => {
		setError(false);
		setObligation(false);
			const employees = [];
			const users = [28];
			const newPlanning = {
				type: "intervention",
				createdBy:userData?.id,
				type_int: '11',
				motif_int: formState?.motif_int || '',
				client_id: selectedClient?.id || formState?.client_id,
				start_datetime: moment(formState?.start_datetime).format('YYYY-MM-DD HH:mm:ss') || '',
				end_datetime: moment(formState?.end_datetime).format('YYYY-MM-DD HH:mm:ss') || '',
				//employee_id: newInterventionData?.employee?.id,
				//voiture: newInterventionData?.employee?.voitures[0]?.id, // modifier !!!
				voitures: formState?.voitures?.map((v) => v?.id),
				//employees_ids: [selectedEmployee2?.id],
				description: formState?.description || '',
				name: formState?.name || '',
				employees_ids: employees,
			};

			setisLoading(true);
			setError(false);

			// createPlanningSlot(
			// 	userData?.password,
			// 	newPlanning,
			// 	(planningData) => {
			// 		!!setEditModalStatus && setEditModalStatus(false);

			// 		if (attachmentsCommercial?.length > 0) {
			// 			// uploadAttachementsCommercial(
			// 			// 	userData?.password,
			// 			// 	planningData?.id,
			// 			// 	attachmentsCommercial,
			// 			// 	() => {
			// 			// 		if (planningData?.client_id?.email) {
			// 			// 			if (planningData?.type_int == 'Pose') {
			// 			// 				// sendInterventionPoseByMail(
			// 			// 				// 	userData?.password,
			// 			// 				// 	planningData?.id,
			// 			// 				// 	true,
			// 			// 				// 	() => {
			// 			// 				// 		updatePoseDevis();
			// 			// 				// 		getInterventions();
			// 			// 				// 		setCreateModalStatus(false);
			// 			// 				// 		setisLoading(false);
			// 			// 				// 	},
			// 			// 				// );
			// 			// 			} else if (
			// 			// 				planningData?.type_int == 'Intervention' ||
			// 			// 				planningData?.type_int == 'Enlèvement'
			// 			// 			) {
			// 			// 				getInterventions();
			// 			// 				setCreateModalStatus(false);
			// 			// 				setisLoading(false);
			// 			// 			} else {
			// 			// 				sendInterventionMail(
			// 			// 					userData?.password,
			// 			// 					planningData?.id,
			// 			// 					() => {
			// 			// 						setPose({});
			// 			// 						getInterventions();
			// 			// 						setCreateModalStatus(false);
			// 			// 						setisLoading(false);
			// 			// 					},
			// 			// 					(error) => {
			// 			// 						setisLoading(false);
			// 			// 						setError(error);
			// 			// 					},
			// 			// 				);
			// 			// 			}
			// 			// 		} else {
			// 			// 			if (planningData?.type_int == 'Pose') {
			// 			// 				updatePoseDevis();
			// 			// 			}
			// 			// 			setPose({});
			// 			// 			getInterventions();
			// 			// 			setEditModalStatus(false);
			// 			// 			setisLoading(false);
			// 			// 			setError(false);
			// 			// 		}
			// 			// 	},
			// 			// 	(error) => {
			// 			// 		setisLoading(false);

			// 			// 		setError(error);
			// 			// 	},
			// 			// );
			// 		} else {
			// 			if (planningData?.client_id?.email) {
			// 				if (planningData?.type_int == 'Pose') {
			// 					// sendInterventionPoseByMail(
			// 					// 	userData?.password,
			// 					// 	planningData?.id,
			// 					// 	true,
			// 					// 	() => {
			// 					// 		updatePoseDevis();
			// 					// 		getInterventions();
			// 					// 		setCreateModalStatus(false);
			// 					// 		setisLoading(false);
			// 					// 		setError(false);
			// 					// 	},
			// 					// );
			// 				} else if (
			// 					planningData?.type_int == 'Intervention' ||
			// 					planningData?.type_int == 'Enlèvement'
			// 				) {
			// 					getInterventions();
			// 					setCreateModalStatus(false);
			// 					setisLoading(false);
			// 					setError(false);
			// 				} else {
			// 					sendInterventionMail(
			// 						userData?.password,
			// 						planningData?.id,
			// 						() => {
			// 							setPose({});
			// 							getInterventions();
			// 							setCreateModalStatus(false);
			// 							setisLoading(false);
			// 							setError(false);
			// 						},
			// 						(error) => {
			// 							setisLoading(false);
			// 							setError(error);
			// 						},
			// 					);
			// 				}
			// 			} else {
			// 				if (planningData?.type_int == 'Pose') {
			// 					updatePoseDevis();
			// 				}
			// 				setPose({});
			// 				getInterventions();
			// 				setCreateModalStatus(false);
			// 				setisLoading(false);
			// 				setError(false);
			// 			}
			// 		}

			// 		createNotification({
			// 			recieverMembers: users,
			// 			text: ` 
			// 							Nouvelle intervention N° ${planningData?.name_seq} de ${planningData?.type_int} ${planningData?.motif
			// 				}
									
			// 							Client: ${planningData?.client_id?.name}
									
			// 						 	Date:${moment(planningData?.start_datetime).format('DD-MM-YYYY')}: ${moment(
			// 					planningData?.start_datetime,
			// 				).format('hh:mm')} - ${moment(planningData?.end_datetime).format('hh:mm')}
			// 							`,
			// 			icon: 'Notifications',
			// 			color: 'info',
			// 			link: planningMenu?.path,
			// 		});
			// 	},

			// 	(error) => {
			// 		setisLoading(false);
			// 		setError(error);
			// 	},
			// );
		
	};

	const handleChange = (e) => {
		setFormState({ ...formState, [e.target.name]: e.target.value });
		setCurentInput({ inputName: [e.target.name] });
	};
	const deleteImage = (key) => {
		const updatedImages = attachmentsCommercial.filter((item, index) => index != key);
		setAttachmentsCommercial(updatedImages);
	};

	const handelSelect = ({ value, selected }) => {
		if (!!selected?.client) {
			setSelectedClient({ ...selected?.client });
			setFormState({ ...formState, ...value });
		}
		if (!!selected?.employee) {
			setSelectedEmployee({ ...selected?.employee });
			setFormState({ ...formState, ...value });
		}
		if (!!selected?.voiture) {
			setSelectedVoiture({ ...selected?.voiture });
			setFormState({ ...formState, ...value });
		}
		if (!!selected?.employee2) {
			setFormState({ ...formState, ...value });
		}
	};

	const handleDevisChange = (e) => {
		setOpenList(true);
		setDevisInputSearch(e?.target?.value);
	};

	const handelSelectDevis = (item) => {
		setOpenList(false);
		const exist = !!formState?.devis_liste?.find((id) => id == item?.id);
		if (!exist) {
			formState.devis_liste = [...formState?.devis_liste, item?.id];
		}
		setDevisDatas([...devisDatas, item]);
		setFilterDevisResult([]);
	};

	const loadDevis = () => {
		// searchDevis(userData?.password, [['id', 'in', formState?.devis_liste]], ({ elements }) => {
		// 	setDevisDatas(elements);
		// });
	};

	useEffect(() => {
		const abortController = new AbortController();
		const signal = abortController.signal;
		if (devisInputSearch === '') {
			setFilterDevisResult([]);
		} else {
			setDevisIsLoading(true);
			// searchDevis(
			// 	userData?.password,
			// 	[
			// 		'|',

			// 		['name', 'ilike', devisInputSearch],

			// 		'|',
			// 		['nom_client', 'ilike', devisInputSearch],

			// 		'|',
			// 		['phone_client', 'ilike', devisInputSearch],

			// 		['mobile_client', 'ilike', devisInputSearch],
			// 	],
			// 	({ elements }) => {
			// 		setFilterDevisResult(elements);
			// 		setDevisIsLoading(false);
			// 	},
			// 	(error) => {
			// 		//setError(error);
			// 		setDevisIsLoading(true);
			// 	},
			// 	signal,
			// );
		}
		return () => {
			abortController.abort();
		};
	}, [devisInputSearch]);

	useEffect(() => {
		formState?.devis_liste?.length > 0 && loadDevis();
	}, [formState?.devis_liste]);

	// const validateForm = () => {
	// 	if (!formState?.type_int || !selectedClient?.name || !formState?.motif) {
	// 		setObligation("Remplir type d'intervention, motif et le client !");
	// 		return false;
	// 	} else if (!moment(formState?.start_datetime).isBefore(formState?.end_datetime)) {
	// 		setObligation('Verifier la date svp !');
	// 		return false;
	// 	}
	// 	return true;
	// };

	const handelSubmit = () => {
		// if (!validateForm()) return;
		setisLoading(true);
		handleCreateIntervention();
		setisLoading(false);
	};


	const getType = async () => {
        try {
            const data = await searchAPI(userData?.accessToken, 'planning-type', {}, 0, 5);
            setCategoryDefaultList(data?.elements)
        } catch (error) {
            console.error("Search error:", error); // Log the error for debugging
            setError(error)
        }
    }

	console.log("formState", formState)
	return (
		<>
			<Modal setIsOpen={() => { }} isOpen={true} size='xl' isScrollable classNameMd='nv-2'>
				<ModalHeader className='px-4 pb-0' setIsOpen={setCreateModalStatus}>
					<div className='w-100 text-muted text-center'>
						<ModalTitle className='fw-semibold fs-4'>Nouvelle Intervention</ModalTitle>
					</div>
				</ModalHeader>
				<ModalBody className='px-4 pt-0'>
					<Card hasTab shadow={'none'}>
						<CardTabItem id='tab' title='Détails'>
							<div className='row'>
								<div className='col-xl-6 col-md-12'>
									<Card>
										<CardHeader>
											<CardLabel icon='InfoOutline' iconColor='primary'>
												<CardTitle>Informations d'intervention</CardTitle>
											</CardLabel>
										</CardHeader>
										<CardBody>
											<div className='row g-4'>
												<FormGroup className='mb-3'>
													<Label>Type Intervention *</Label>
													{/* <div className="d-flex col-12 gap-2">
														<SearchBox
															className={!!formState?.type_int ? "col-9" : "col-12"}
															selectedItem={formState?.type_int}
															handleSearch={handleSearch}
															handelSelect={(i)=> {
																setFormState({
																	...formState,
																	type_int:i
																});
															}}
															defaultList={[]}
															setOpenPop={(e) => {
																setOpenCategoryPopup(e)
																setSelectedCategory(null)

															}}
															onTextChange={(text) => setSearchTextCat(text)}
															displayedItem={(item) => getDisplayName(item)}
														/>
														{!!formState?.type_int &&
															<div className="d-flex gap-2">
																<Button color='info' isLight icon='OpenInNew' onClick={() => {
																	setSelectedCategory(formState?.type_int)
																	setOpenCategoryPopup(true)
																}}>Voir</Button>
																<Button color='danger' isLight icon='Trash' onClick={() => {
																	setSelectedCategory(null)
																	setFormState({
																		...formState,
																		type_int:null
																	});
																}} /></div>}

													</div> */}

												</FormGroup>
										
												<FormGroup className='mb-3'>
													<Label>Motif Intervention *</Label>
													{/* <div className="d-flex col-12 gap-2">
														<SearchBox
															className={!!formState?.motif_int ? "col-9" : "col-12"}
															selectedItem={formState?.motif_int}
															handleSearch={handleSearch}
															handelSelect={(i)=> {
																setFormState({
																	...formState,
																	motif_int:i
																});
															}}
															defaultList={[]}
															setOpenPop={(e) => {
																setOpenCategoryPopup(e)
																setSelectedCategory(null)

															}}
															onTextChange={(text) => setSearchTextCat(text)}
															displayedItem={(item) => getDisplayName(item)}
														/>
														{!!formState?.motif_int &&
															<div className="d-flex gap-2">
																<Button color='info' isLight icon='OpenInNew' onClick={() => {
																	setSelectedCategory(formState?.motif_int)
																	setOpenCategoryPopup(true)
																}}>Voir</Button>
																<Button color='danger' isLight icon='Trash' onClick={() => {
																	setSelectedCategory(null)
																	setFormState({
																		...formState,
																		motif_int:null
																	});
																}} /></div>}

													</div> */}

												</FormGroup>
											

												<div className='row mt-5 d-flex justify-content-between'>
													<div className='col-auto'>
														<Label>Employés</Label>
														<div className='ms-3'>
															{formState?.employees_ids?.map((item, idx) => (
																<div key={idx}>
																	{item?.userName?.split('_')[1]}
																</div>
															))}
														</div>
													</div>
													<div className='col-auto d-flex justify-content-end align-self-start'>
														<Button
															color={'primary'}
															//className='w-auto'
															size={'sm'}
															isLight
															onClick={() => {
																setEmployeePopup(true);
															}}>
															<Icon
																icon='add'
																size='2x'
																className=''></Icon>{' '}
															Ajouter Employé
														</Button>
													</div>
												</div>

												<FormGroup
													className='col-12'
													id='eventStart'
													label='Date de début'>
													<Input
														type={'datetime-local'}
														/* onChange={handleChange} */
														value={moment(
															formState?.start_datetime,
														).format(moment.HTML5_FMT.DATETIME_LOCAL)}
														name='start_datetime'
														autoComplete='off'
														onChange={handleChange}

													//disabled={true}
													/>
												</FormGroup>
												<FormGroup id='eventEnd' label='Date de fin'>
													<Input
														type={'datetime-local'}
														/* onChange={handleChange} */
														value={moment(
															formState?.end_datetime,
														).format(moment.HTML5_FMT.DATETIME_LOCAL)}
														name='end_datetime'
														onChange={handleChange}
														autoComplete='off'
													/>
												</FormGroup>
											</div>
										</CardBody>
									</Card>
								</div>
								<div className='col-xl-6 col-md-12'>
									<Card shadow='sm' stretch>
										<CardHeader>
											<CardLabel icon='InfoOutline' iconColor='primary'>
												<CardTitle>
													Information Client
												</CardTitle>
											</CardLabel>
										</CardHeader>
										<CardBody>
											<div className='row g-4'>
												<SearchBoxClient
													setSelectedClient={setSelectedClient}
													selectedClient={selectedClient}
													handelSelect={handelSelect}
												/>
												<FormGroup
													className='col-12'
													id='client'
													label={t('Remarques')}>
													<Textarea
														name='description'
														placeholder={t('Remarques') + '...'}
														id='description'
														value={formState?.description}
														onChange={(e) => {
															handleChange(e);
															// e.target.style.height = 'auto';
															// e.target.style.height = `${e?.target?.scrollHeight}px`;
														}}
													/>
												</FormGroup>
												

												<div className='row g-4 d-flex align-items-center'>
													<FormGroup
														className='col-12'
														id='client'
														label={'Fichiers'}>
														<Input
															type='file'
															multiple
															name='attachmentsCommercial'
															onChange={(e) => {
																const newAttachments = Array.from(
																	e?.target?.files,
																);
																setAttachmentsCommercial(
																	(prevAttachments) => [
																		...prevAttachments,
																		...newAttachments,
																	],
																);
															}}
														/>
													</FormGroup>
													<div className='row'>
														{!!attachmentsCommercial?.length &&
															attachmentsCommercial?.map(
																(file, index) => {
																	return (
																		<Attachements
																			key={index}
																			file={file}
																			index={index}
																			deleteImage={
																				deleteImage
																			}
																		/>
																	);
																},
															)}
													</div>
												</div>
											</div>
										</CardBody>
									</Card>
								</div>
							</div>
						</CardTabItem>
						<CardTabItem id='Devis' title='Devis'>
							<div className='d-flex justify-content-end '>
								{formState?.state != 'done' &&
									formState?.state != 'cancel' &&
									formState?.type_int != 'Pose' && (
										<Button
											className=''
											color='success'
											icon='PostAdd'
											onClick={() => setEditDevisModalStatus(true)}>
											Créer un devis
										</Button>
									)}
								{formState?.state != 'done' &&
									formState?.state != 'cancel' &&
									formState?.type_int == 'Pose' &&
									!!devisDatas?.length && (
										<Button
											className='w-auto ms-2 '
											color='warning'
											icon='PostAdd'
											onClick={() => setConfirmCreatePVPopup(true)}>
											Créer un PV de réception
										</Button>
									)}
								{/* <Button
									className='w-auto ms-2'
									color='primary'
									icon='PostAdd'
									hoverShadow='none'
									onClick={() => setConfirmDecharge(true)}>
									Créer une décharge
								</Button> */}
							</div>
							{userData?.role != 'Technicien' &&
								userData?.role?.toLocaleLowerCase() != 'achat' && (
									<div className='col-lg-6 mb-3' ref={ref}>
										<FormGroup className='autocomplete'>
											<Input
												placeholder='🔎︎ Rechercher par devis, client ...'
												onChange={handleDevisChange}
												onFocus={handleDevisChange}
												value={devisInputSearch}
												name='name'
												autoComplete='off'
											/>
											{openList && devisIsLoading ? (
												<div
													id='myInputautocomplete-list'
													className='autocomplete-items'>
													<div className='body'>
														<div tag={'button'}>
															<Spinner isSmall isGrow />{' '}
															<Spinner isSmall isGrow />{' '}
															<Spinner isSmall isGrow />
														</div>
													</div>
												</div>
											) : (
												!!filterDevisResult?.length && (
													<div
														id='myInputautocomplete-list'
														className='autocomplete-items'>
														<div className='body'>
															{filterDevisResult?.map((item, idx) => (
																<div
																	className='d-flex g-1'
																	key={idx}
																	onClick={() => {
																		handelSelectDevis(item);
																	}}>
																	<div className='w-auto'>
																		<small className={` px-2 `}>
																			<Icon
																				icon='Info'
																				className='me-1'
																				size={'lg'}
																			/>
																			<span className='text-dark'>
																				{item?.name}
																			</span>
																		</small>
																	</div>
																	<div className='w-auto'>
																		<small className={` px-2 `}>
																			<Icon
																				icon='Person'
																				className='me-1'
																				size={'lg'}
																			/>
																			<span className='text-dark'>
																				{item?.nom_client}
																			</span>
																		</small>
																	</div>
																	{(!!item?.phone_client ||
																		!!item?.mobile_client) && (
																			<div className='w-auto '>
																				<small
																					className={`  px-2   `}>
																					<Icon
																						icon='LocalPhone'
																						className='me-1'
																						size={'lg'}
																					/>
																					<span className='text-dark'>
																						{
																							item?.phone_client
																						}{' '}
																						{
																							item?.mobile_client
																						}
																					</span>
																				</small>
																			</div>
																		)}

																	<div className='w-auto '>
																		<small
																			className={`  px-2   `}>
																			<Icon
																				icon='Today'
																				className='me-1'
																				size={'lg'}
																			/>
																			<span className='text-dark'>
																				{moment(
																					item?.create_date,
																				).format(
																					'DD/MM/yyyy',
																				)}
																			</span>
																		</small>
																	</div>
																</div>
															))}
														</div>
													</div>
												)
											)}
										</FormGroup>
									</div>
								)}
							<div className='row mt-3'>
								{!!devisDatas?.length &&
									devisDatas?.map((devis, idx) => {
										return (
											<div className='col-lg-4 col-md-6 col-sm-12' key={idx}>
												<Card isCompact>
													<CardHeader>
														<CardLabel>
															<Label>Devis - {t(devis?.state)}</Label>
														</CardLabel>
														{userData?.role != 'Technicien' &&
															userData?.role?.toLocaleLowerCase() !=
															'achat' && (
																<CardActions>
																	<Icon
																		className='cursor-pointer'
																		icon='Delete'
																		color='danger'
																		size={'2x'}
																		onClick={() => {
																			console.log(
																				'delete last devis :',
																				formState?.devis_liste?.filter(
																					(item) =>
																						item !=
																						devis?.id,
																				),
																			);
																			setFormState({
																				...formState,
																				devis_liste:
																					formState?.devis_liste?.filter(
																						(item) =>
																							item !=
																							devis?.id,
																					),
																			});
																			setDevisDatas(
																				devisDatas?.filter(
																					(item) =>
																						item?.id !=
																						devis?.id,
																				),
																			);
																		}}></Icon>
																</CardActions>
															)}
													</CardHeader>
													<CardBody>
														<DevisCard
															card={devis}
															loadData={loadDevis}
														/>
													</CardBody>
												</Card>
											</div>
										);
									})}
							</div>
							{/* <div className='row mt-3'>
								{!!facturesDatas?.length &&
									facturesDatas?.map((facture) => {
										return (
											<div
												className='col-lg-4 col-md-6 col-sm-12'
												key={facture?.id}>
												<Card isCompact>
													<CardHeader>
														<CardLabel>
															<Label>
																Facture - {t(facture?.state)}
															</Label>
														</CardLabel>
													</CardHeader>
													<CardBody>
														<FactureCard
															card={facture}
															loadFactures={loadDevis}
														/>
													</CardBody>
												</Card>
											</div>
										);
									})}
							</div> */}
						</CardTabItem>
					</Card>
				</ModalBody>

				<ModalFooter className='px-4 pb-4'>
					<Button
						color='primary'
						className='w-100'
						type='submit'
						onClick={() => {
							handelSubmit();
						}}
						isDisable={isLoading}>
						{isLoading && <Spinner isSmall inButton />}
						{isLoading ? 'En cours' : t('Create')}
					</Button>
					<Button
						color='warning'
						className='w-100'
						onClick={() => setCreateModalStatus(false)}>
						{t('Cancel')}
					</Button>
				</ModalFooter>
				{!!obligation && (
					<StatusPopup
						icon='Cancel'
						color='danger'
						title={obligation}
						setOpen={setObligation}
					/>
				)}
				{!!error && <ErrorPopup error={error} setOpen={setError} />}
			</Modal>
			{searchModalStatus && (
				<SearchClient
					setCreateClientModalStatus={setSearchModalStatus}
					handelSelect={handelSelect}
					data={isFournisseur ? {} : selectedClient}
					curentInput={curentInput}
					onChange={handleChange}
					newClient={isFournisseur}
				/>
			)}
			{editDevisModalStatus && (
				<DevisLinesContextProvider>
					<DevisPopUp
						card={newDevisData}
						setEditModalStatus={(param) => {
							setEditDevisModalStatus(param);
						}}
						loadData={loadDevis}
					/>
				</DevisLinesContextProvider>
			)}
			{!!voiturePopup && (
				<VoiturePopup
					setVoiturePopup={setVoiturePopup}
					formState={formState}
					setFormState={setFormState}
				/>
			)}
			
			{!!employeePopup && (
				<EmployeePopup
					setOpenPopup={setEmployeePopup}
					data={formState?.employees_ids}
					handleUpdate={(list) => setFormState({ ...formState, employees_ids: list })}
				/>
			)}
		</>
	);
};

InterventionCreatePopUp.propTypes = {
	setCreateModalStatus: PropTypes.func.isRequired,
	// eslint-disable-next-line react/forbid-prop-types
	/* setNewPlanningData: PropTypes.func.isRequired, */
	newInterventionData: PropTypes.any.isRequired,
	getInterventions: PropTypes.func.isRequired,
};

export default InterventionCreatePopUp;
